<script>
import MenuBar from '../components/MenuBar.vue'

import { getAdmini, getAtlasIndex } from '@/api/partyTop'

export default {
  components: { MenuBar },
  data() {
    return {
      village: localStorage.getItem('currentCommunity') || '',
      adminiListShow: false,
      currentAdminiLevel: '县', // 县/乡镇/村社区
      currentAdminiName: '',
      allCountyData: [],
      countyList: [],
      currentCounty: '洪雅县',
      townshipList: [],
      currentTownship: '全部乡镇',
      villageList: [],
      currentVillage: '全部村/社区',
      oldImgList: [],
      newImgList: [],
      imgTransition: false
    }
  },
  computed: {
    currentAdminiList() {
      let arr = []
      switch (this.currentAdminiLevel) {
        case '县': arr = this.countyList
          break
        case '乡镇': arr = this.townshipList
          break
        case '村社区': arr = this.villageList
          break
        default: arr = this.countyList
      }
      return arr
    },
    choseLevelId() {
      let levelId = 1
      if (this.currentAdminiName === '洪雅县') levelId = 1
      if (this.countyList.slice(1, this.countyList.length).filter(item => item.name === this.currentAdminiName).length > 0) levelId = 2
      if (this.townshipList.filter(item => item.name === this.currentAdminiName).length > 0) levelId = 3
      if (this.villageList.filter(item => item.name === this.currentAdminiName).length > 0) levelId = 4
      return levelId
    }
  },
  watch: {
    currentTownship(newVal) {
      if (newVal && newVal !== '全部乡镇') {
        this.allCountyData.forEach(item => {
          if (item.township === newVal) {
            const villageArr = []
            item.list && item.list.length > 0 && item.list.forEach(item => {
              villageArr.push({ name: item.name, id: item.id })
            })
            this.villageList = [{ name: '全部村/社区', id: 0 }, ...villageArr]
          }
        })
      } else this.villageList = [{ name: '全部村/社区', id: 0 }]
    },
    currentAdminiName(newVal) {
      const countyArr = this.countyList.filter(item => item.name === newVal)
      const townshipArr = this.townshipList.filter(item => item.name === newVal)
      // const villageArr = this.villageList.filter(item => item.name === newVal)
      if (countyArr.length > 0) {
        this.currentTownship = '选择乡镇'
        this.currentVillage = '选择村/社区'
      }
      if (townshipArr.length > 0) {
        this.currentVillage = '选择村/社区'
      }
    }
    // currentAdminiLevel(newVal) {
    //   switch (newVal) {
    //     case '县':
    //       this.currentCounty = '洪雅县'
    //       this.currentTownship = '全部乡镇'
    //       this.currentVillage = '全部村/社区'
    //       this.currentAdminiName = '洪雅县'
    //       break
    //     case '乡镇':
    //       this.currentVillage = '全部村/社区'
    //       this.currentAdminiName = '全部乡镇'
    //       break
    //     case '村社区':
    //       this.currentVillage = '全部村/社区'
    //       this.currentAdminiName = '全部村/社区'
    //       break
    //   }
    // }
  },
  created() {
    this.getAllAdmini()
  },
  methods: {
    toHometownAtlasDetail() {
      const townshipParam = this.choseLevelId === 4 && this.currentVillage === '全部村/社区' ? this.currentTownship : ''
      const query = { adminiName: this.currentAdminiName, choseLevelId: this.choseLevelId, townshipParam }
      this.$router.push({ path: '/hometownAtlasDetail', query })
    },
    onCountyDrop() {
      this.currentAdminiLevel === '县'
        ? this.adminiListShow = !this.adminiListShow
        : this.adminiListShow = true
      this.currentAdminiLevel = '县'
    },
    onTownShipDrop() {
      if (this.currentCounty !== '洪雅县') return
      this.currentAdminiLevel === '乡镇'
        ? this.adminiListShow = !this.adminiListShow
        : this.adminiListShow = true
      this.currentAdminiLevel = '乡镇'
      if (this.currentCounty === '洪雅县') this.currentAdminiLevel = '乡镇'
    },
    onVillageDrop() {
      if (this.currentCounty !== '洪雅县') return
      this.currentAdminiLevel === '村社区'
        ? this.adminiListShow = !this.adminiListShow
        : this.adminiListShow = true
      this.currentAdminiLevel = '村社区'
      if (this.currentTownship !== '全部乡镇') this.currentAdminiLevel = '村社区'
    },

    onAdminiItemClick(name) {
      this.imgTransition = false
      if (name === 'firstName') {
        switch (this.currentAdminiLevel) {
          case '县':
            this.currentAdminiName = '洪雅县'
            this.currentCounty = '洪雅县'
            break
          case '乡镇':
            this.currentAdminiName = '全部乡镇'
            this.currentTownship = '全部乡镇'
            break
          case '村社区':
            this.currentAdminiName = '全部村/社区'
            this.currentVillage = '全部村/社区'
            break
        }
        this.adminiListShow = false
        this.getAtlasList(this.currentAdminiName)
        return
      }
      this.getAtlasList(name)
      this.currentAdminiName = name
      switch (this.currentAdminiLevel) {
        case '县':
          this.currentCounty = name
          this.adminiListShow = false
          break
        case '乡镇':
          this.currentTownship = name
          this.adminiListShow = false
          break
        case '村社区':
          this.currentVillage = name
          this.adminiListShow = false
          break
      }
    },

    getAllAdmini() {
      getAdmini().then(res => {
        if (res.code === 0) {
          const { msg = [], msg2 = [] } = res
          this.countyList = [{ name: '洪雅县', id: 0 }, ...msg]
          this.currentAdminiName = '洪雅县'

          this.allCountyData = msg2
          const townshipArr = []
          msg2.length > 0 && msg2.forEach(item => {
            townshipArr.push({ name: item.township, id: item.id })
          })
          this.townshipList = [{ name: '全部乡镇', id: 0 }, ...townshipArr]
        }
        this.getAtlasList('洪雅县')
      })
    },
    getAtlasList(adminiName) {
      this.$nextTick(() => {
        const townshipParam = this.choseLevelId === 4 && this.currentVillage === '全部村/社区' ? this.currentTownship : ''
        const params = {
          village: adminiName,
          status: this.choseLevelId,
          township: townshipParam,
          name: this.village
        }
        getAtlasIndex(params).then(res => {
          if (res.code === 0) {
            const { msg = [], msg2 = [] } = res
            this.oldImgList = msg
            this.newImgList = msg2
            this.imgTransition = true
          }
        })
      })
    },

    judgeHasAdminiName(level) {
      let bool = false
      switch (level) {
        case '县': bool = this.countyList.filter(item => item.name === this.currentAdminiName).length > 0
          break
        case '乡镇': bool = this.townshipList.filter(item => item.name === this.currentAdminiName).length > 0
          break
        case '村社区': bool = this.villageList.filter(item => item.name === this.currentAdminiName).length > 0
          break
      }
      return bool
    }
  }
}
</script>

<template>
  <div class="page-container">
    <menu-bar />
    <el-image class="hy-logo" :src="require('imgs/partyTop/hy-logo.png')" alt="hy-logo" />

    <div class="atlas-container-1" @click="toHometownAtlasDetail">
      <el-image
        v-for="(v, i) in oldImgList"
        :key="`atlas-item-${i}`"
        class="atlas-img atlas-img-old"
        :src="v.oldImg | imgPath"
        alt="atlas"
        fit="cover"
      />
    </div>
    <div
      class="atlas-container-2 atlas-container-2-only"
      :class="{'move-transition2': imgTransition}"
      @click="toHometownAtlasDetail"
    >
      <div class="img-box">
        <el-image
          v-for="(v, i) in newImgList.slice(0, 4)"
          :key="`atlas1-${i}`"
          class="atlas-img"
          :src="v.newImg | imgPath"
          alt="atlas"
          fit="cover"
        />
      </div>
    </div>
    <div
      class="atlas-container-2 atlas-container-3"
      :class="{'move-transition3': imgTransition}"
      @click="toHometownAtlasDetail"
    >
      <div class="img-box">
        <el-image
          v-for="(v, i) in newImgList.slice(4, 8)"
          :key="`atlas2-${i}`"
          class="atlas-img"
          :src="v.newImg | imgPath"
          alt="atlas"
          fit="cover"
        />
      </div>
    </div>

    <div class="admini-container">
      <div class="admini-menu">
        <!-- county -->
        <p
          class="admini-menu-item"
          :class="{'admini-menu-item-normal': !judgeHasAdminiName('县')}"
          @click="onCountyDrop"
        >
          {{ currentCounty | textLenHandler(4) }}
          <i
            :class="adminiListShow && currentAdminiLevel === '县'
              ? 'el-icon-arrow-down'
              : 'el-icon-arrow-right'"
          />
        </p>
        <!-- township -->
        <p
          v-if="currentCounty === '洪雅县'"
          class="admini-menu-item"
          :class="{'admini-menu-item-normal': !judgeHasAdminiName('乡镇')}"
          @click="onTownShipDrop"
        >
          {{ currentTownship | textLenHandler(4) }}
          <i
            :class="adminiListShow && currentAdminiLevel === '乡镇'
              ? 'el-icon-arrow-down'
              : 'el-icon-arrow-right'"
          />
        </p>
        <!-- village -->
        <p
          v-if="currentCounty === '洪雅县' && currentTownship !== '全部乡镇' && currentTownship !== '选择乡镇'"
          class="admini-menu-item"
          :class="{'admini-menu-item-normal': !judgeHasAdminiName('村社区')}"
          @click="onVillageDrop"
        >
          {{ currentVillage | textLenHandler(6) }}
          <i
            :class="adminiListShow && currentAdminiLevel === '村社区'
              ? 'el-icon-arrow-down'
              : 'el-icon-arrow-right'"
          />
        </p>
      </div>

      <Transition name="adminiList-transfrom">
        <div v-show="adminiListShow" class="admini-list">
          <div
            v-if="currentAdminiList && currentAdminiList.length > 0"
            class="admini-list-top"
            :class="{'admini-list-top-active': currentAdminiName === currentAdminiList[0].name}"
            @click="onAdminiItemClick('firstName')"
          >
            {{ currentAdminiList[0].name }}
          </div>
          <div class="admini-list-bottom">
            <p
              v-for="(v, i) in currentAdminiList.slice(1, currentAdminiList.length)"
              :key="`admini-item-${i}`"
              class="admini-item"
              :class="{'admini-item-active': currentAdminiName === v.name}"
              @click="onAdminiItemClick(v.name)"
            >{{ v.name }}</p>
          </div>
        </div>
      </Transition>
    </div>
    <!-- currentAdminiName-{{ currentAdminiName }}
    currentAdminiLevel-{{ currentAdminiLevel }}
    choseLevelId-{{ choseLevelId }} -->
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  // background: fff;
  background: url('~imgs/partyTop/atlas-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: table;
  position: relative;
  .hy-logo {
    position: absolute;
    top: 26px;
    left: 26px;
    width: 87px;
    height: 50px;
  }
}
.atlas-container-1, .atlas-container-2 {
  display: flex;
  padding: 30px 15px;
  box-sizing: border-box;
  column-gap: 13px;
}
.atlas-img {
  width: 157px;
  height: 120px;
  flex-shrink: 0;
  cursor: pointer;
}
.atlas-img-old {
  filter: sepia(60%);
  -webkit-filter: sepia(60%);
}
.atlas-container-1 {
  width: 355px;
  height: 180px;
  background: url('~imgs/partyTop/atlas-bg.png') no-repeat center;
  background-size: 100% 100%;
  margin: 144px 0 0 750px;
}
.atlas-container-2 {
  width: 640px;
  height: 180px;
  background: url('~imgs/partyTop/atlas-bg2.png') no-repeat center;
  background-size: 100% 100%;
  margin: 14px 0 0 920px;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    height: 120px;
    width: 100px;
    left: 525px;
    right: 0;
    bottom: 0;
    top: 30px;
    box-shadow: #E9CDBC -20px 0 20px -8px inset;
    z-index: 2;
  }
  .img-box {
    width: 610px;
    height: 120px;
    display: flex;
    box-sizing: border-box;
    column-gap: 13px;
    overflow-x: scroll;
    &::-webkit-scrollbar { // chrome/safari
      display: none;
    }
    scrollbar-width: none; // firefox
    -ms-overflow-style: none; // IE10+
  }
}
// .atlas-container-2-only {
//   .atlas-img {
//     animation: img-move ease-in-out 1s;
//     animation-delay: .5s;
//   }
// }
// .atlas-container-3 {
//   .atlas-img {
//     animation: img-move ease-in-out 1s;
//     animation-delay: 1.2s;
//   }
// }
.move-transition2 {
  .atlas-img {
    animation: img-move ease-in-out 1s;
    animation-delay: .5s;
  }
}
.move-transition3 {
  .atlas-img {
    animation: img-move ease-in-out 1s;
    animation-delay: 1.2s;
  }
}
.atlas-container-3 {
  margin: 28px 0 0 450px;
}

.admini-container {
  width: 426px;
  height: 213px;
  margin: 72px 0 0 1175px;
}
.admini-menu {
  width: 426px;
  display: flex;
  column-gap: 9px;
  .admini-menu-item {
    width: 134px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    box-sizing: border-box;
    cursor: pointer;

    background-color: #FFFCBF;
    border-radius: 10px;
    background-image: url('~imgs/partyTop/btn-bg.png');
    background-repeat: no-repeat;
    background-position: 90px 9px;
    background-size: 43px 39px;

    font-size: 16px;
    font-weight: bold;
    color: #9D011A;
    i {
      font-size: 16px;
      font-weight: bold;
      margin-top: 2px;
    }
  }
  .admini-menu-item-normal {
    background-image: none;
    background-color: #CCB2B4;

    color: #fff;
  }
}
.admini-list {
  width: 426px;
  height: 150px;
  background: #FFFDDD;
  border-radius: 10px;
  margin-top: 15px;
  padding-top: 12px;
  box-sizing: border-box;
  .admini-list-top {
    width: 100px;
    height: 33px;
    background: #F4E4C9;
    border-radius: 6px;
    text-align: center;
    line-height: 33px;
    margin-left: 12px;
    cursor: pointer;

    font-size: 14px;
    font-weight: bold;
    color: #98041A;
  }
  .admini-list-top-active {
    background: #98041A;
    color: #FFFCBF;
  }
  .admini-list-bottom {
    width: 414px;
    height: 78px;
    margin: 15px 0 0 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #cdcdcd;
      border-radius: 3px;
    }
    .admini-item {
      width: 126px;
      height: 33px;
      text-align: center;
      line-height: 33px;
      background: #F4E4C9;
      border-radius: 6px;
      cursor: pointer;

      font-size: 14px;
      font-weight: bold;
      color: #98041A;
    }
    .admini-item-active {
      background: #98041A;
      color: #FFFCBF;
    }
  }
}

@keyframes img-move {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-57px);
  }
  100% {
    transform: translateX(0);
  }
}

/* adminiList-transfrom */
.adminiList-transfrom-enter-active, .adminiList-transfrom-leave-active {
  transition: all ease-in-out .2s;
}
.adminiList-transfrom-enter, .adminiList-transfrom-leave-to {
  opacity: 0;
  transform: translateY(100px);
}
.adminiList-transfrom-enter-to, .adminiList-transfrom-leave {
  opacity: 1;
  transform: translateX(0);
}
</style>
